export default __webpack_public_path__ + "static/media/hotels.772bf525.jpg";